import React from "react";
import { Link } from "react-router-dom";

import Logo from "../../assets/img/logo/footer-logo.png";
import blogImg1 from "../../assets/img/footer/ft-1.png";
import blogImg2 from "../../assets/img/footer/ft-2.png";
import shapeImg1 from "../../assets/img/footer/ft-shape-1.png";
import shapeImg2 from "../../assets/img/footer/ft-shape-2.png";
import footerBG from "../../assets/img/footer/footer-bg.jpg";

const FooterTwo = (props) => {
  const { footerLogo, footerClass } = props;
  return (
    <footer>
      <div
        className={
          footerClass
            ? footerClass
            : "footer-2__area footer-2__plr p-relative fix"
        }
        style={{ backgroundImage: `url(${footerBG})` }}
      >
        <div className="footer-2__shape-1 d-none d-xl-block">
          <img src={shapeImg1} alt="" />
        </div>
        <div className="footer-2__shape-2 d-none d-xl-block">
          <img src={shapeImg2} alt="" />
        </div>
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer-2__widget footer-2-col-1">
                <div className="footer-2__logo">
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        background: "#FFDC60",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: "800",
                        color: "#232323",
                        border: "2px solid white",
                      }}
                    >
                      AM
                    </div>
                    <span
                      style={{
                        fontSize: "1.6rem",
                        fontWeight: "700",
                        color: "white",
                      }}
                    >
                      Ayush Mishra
                    </span>
                  </Link>
                </div>
                <div className="footer-2__content">
                  <div className="footer-2__text">
                    <p>
                      Specializing in React & React Native business
                      applications. I help companies streamline operations with
                      custom inventory management, employee tracking, and
                      analytics solutions.
                    </p>
                  </div>
                  <div className="footer-2__social-box">
                    <span>Connect With Me:</span> <br />
                    <a
                      href="https://www.linkedin.com/in/ayush-mishra-526823280/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                    <a
                      href="https://github.com/IMshadow8802"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-github"></i>
                    </a>
                    <a href="mailto:ayushmishra7352@gmail.com">
                      <i className="far fa-envelope"></i>
                    </a>
                    <a href="tel:+918802487352">
                      <i className="fas fa-phone"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer-2__widget footer-2-col-2">
                <h4 className="footer-2__title">
                  <span>Services</span>
                </h4>
                <div className="footer-2__menu-list">
                  <ul>
                    <li>
                      <Link to="/projects">Inventory Management</Link>
                    </li>
                    <li>
                      <Link to="/projects">Employee Tracking</Link>
                    </li>
                    <li>
                      <Link to="/projects">Business Analytics</Link>
                    </li>
                    <li>
                      <Link to="/projects">Mobile App Development</Link>
                    </li>
                    <li>
                      <Link to="/projects">API Integration</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer-2__widget footer-2-col-3">
                <h4 className="footer-2__title">
                  <span>Quick Links</span>
                </h4>
                <div className="footer-2__menu-list">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about">About Me</Link>
                    </li>
                    <li>
                      <Link to="/projects">My Projects</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/in/ayush-mishra-526823280/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        LinkedIn Profile
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer-2__widget footer-2-col-4">
                <h4 className="footer-2__title">
                  <span>Get In Touch</span>
                </h4>

                {/* Contact Information */}
                <div
                  className="footer-2__contact-info"
                  style={{ marginBottom: "25px" }}
                >
                  <div
                    style={{
                      marginBottom: "15px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <i
                      className="far fa-envelope"
                      style={{ color: "#FFDC60", fontSize: "16px" }}
                    ></i>
                    <a
                      href="mailto:ayushmishra7352@gmail.com"
                      style={{ color: "white", textDecoration: "none" }}
                    >
                      ayushmishra7352@gmail.com
                    </a>
                  </div>
                  <div
                    style={{
                      marginBottom: "15px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <i
                      className="fas fa-phone"
                      style={{ color: "#FFDC60", fontSize: "16px" }}
                    ></i>
                    <a
                      href="tel:+918802487352"
                      style={{ color: "white", textDecoration: "none" }}
                    >
                      +91 8802487352
                    </a>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <i
                      className="fas fa-map-marker-alt"
                      style={{ color: "#FFDC60", fontSize: "16px" }}
                    ></i>
                    <span style={{ color: "white" }}>Delhi, India</span>
                  </div>
                </div>

                {/* Technologies */}
                <div className="footer-2__tech-stack">
                  <h5
                    style={{
                      color: "#FFDC60",
                      marginBottom: "15px",
                      fontSize: "16px",
                    }}
                  >
                    Technologies I Use:
                  </h5>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "8px",
                    }}
                  >
                    {[
                      "React",
                      "React Native",
                      "Node.js",
                      "MongoDB",
                      "JavaScript",
                    ].map((tech, index) => (
                      <span
                        key={index}
                        style={{
                          background: "rgba(255, 220, 96, 0.2)",
                          color: "white",
                          padding: "4px 10px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "500",
                        }}
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright__area copyright__plr-2 black-bg-3">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div
              className="col-md-6 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="copyright__text text-center text-md-start">
                <span>© 2025 Ayush Mishra. All Rights Reserved.</span>
              </div>
            </div>
            <div
              className="col-md-6 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="copyright__item text-center text-md-end">
                <span>
                  <Link to="/">Home</Link>
                </span>
                <span>
                  <Link to="/projects">Projects</Link>
                </span>
                <span>
                  <Link to="/about">About</Link>
                </span>
                <span>
                  <Link to="/contact">Contact</Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;
